import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage/local-storage.service';

import { CodeRequestModel, ResponseModel } from '@core/api';

export interface RequestId {
  requestId: string;
  phoneNumber: string;
  countryCode: string;
  time: number
}

@Injectable({
  providedIn: 'root'
})
export class RequestIdService extends LocalStorageService<RequestId> {

  constructor () {
    super('REQUEST_ID');
  }

  save(phone) {
    return (res: ResponseModel<CodeRequestModel>) => {
      this.value = {
        countryCode: '375',
        phoneNumber: phone,
        requestId: res.data.request_id,
        time: Date.now()
      };
    }
  }
}
